export const SIZES = ['small', 'medium', 'large'];
export type SizesType = 'small' | 'medium' | 'large';
export const CELL_SIZE = 50;
